import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { getSvgStyles } from 'baseui/icon';
import { styled } from '../../../theme/utils.js';
import { Icon } from '../icon.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Svg = forwardRef((_a, ref) => {
  var _b = _a, { title, titleId } = _b, props = __objRest(_b, ["title", "titleId"]);
  return jsxs("svg", __spreadProps(__spreadValues({}, props), { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", ref, "aria-labelledby": titleId, children: [title ? jsx("title", { id: titleId, children: title }) : null, jsx("path", { fill: "currentColor", d: "M18.4023 5.01028H15.9883V3.57428L14.4023 1.98828H9.57328L7.98828 3.57428V5.01028H5.57428L3.98828 6.59628V18.4133L5.57328 19.9993H7.98728C7.43528 19.9993 6.98828 20.4473 6.98828 20.9993C6.98828 21.5513 7.43628 21.9993 7.98828 21.9993C8.54028 21.9993 8.98828 21.5513 8.98828 20.9993C8.98828 20.4473 8.54128 20.0003 7.98928 19.9993H15.9873C15.4353 19.9993 14.9883 20.4473 14.9883 20.9993C14.9883 21.5513 15.4363 21.9993 15.9883 21.9993C16.5403 21.9993 16.9883 21.5513 16.9883 20.9993C16.9883 20.4473 16.5413 20.0003 15.9893 19.9993H18.4023L19.9883 18.4133V6.59628L18.4023 5.01028ZM9.98828 4.40328L10.4023 3.98928H13.5743L13.9883 4.40328V5.01028H9.98828V4.40328ZM17.9883 17.5863L17.5743 18.0003H6.40228L5.98828 17.5863V7.42428L6.40228 7.01028H17.5743L17.9883 7.42428V17.5863Z" })] }));
});
const StyledSvg = styled(Svg, getSvgStyles);
const overrides = {
  Svg: {
    component: StyledSvg
  }
};
const IconSuitcase = forwardRef((props, ref) => jsx(Icon, __spreadValues({ ref, overrides }, props)));
IconSuitcase.displayName = "IconSuitcase";

export { IconSuitcase };
